<template>
  <div>
    <v-card width="450" class="mx-auto mt-5" @keyup.native.enter="login()">
        <validation :errors="errors" />
        <v-card-title>
            <h1 class="headline">Login</h1>
        </v-card-title>
        <v-card-text>
            <v-text-field v-model="username" prepend-icon="mdi-account-circle" label="Email" />
            <v-text-field  v-model="password" type="password" prepend-icon="mdi-lock" label="Password" />           
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="login()" :disabled="loading" :dark="!loading" depressed>Login</v-btn>
        </v-card-actions>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    </v-card>
  </div>
</template>

<script>
import { auth } from '@/services/api';
import products from "@/services/products";
import Validation from "@/components/common/Validation";

export default {
    data: () => ({
        password: "",
        username: "",
        loading: false,
        errors: []
    }),
    components: { Validation },
    methods: {
        async login() {
            this.loading = true;
            this.errors = [];
            
            if (await auth(this.username, this.password)) {
                const ps = products.list();

                if (ps.length > 0)
                    this.$router.replace({ name: "ProductView", params: { id: ps[0].id } });
                else
                    this.$router.replace("/");
            } else {
                this.loading = false;
                this.errors.push("Email or password is incorrect.");
            }
        }
    }
};
</script>
